import * as action from "./actions";

export const getVendor = id => {
  return {
    type: action.GET_VENDOR,
    payload: id
  };
};

export const setVendor = vendor => {
  return {
    type: action.SET_VENDOR,
    payload: vendor
  };
};

const ACTION_HANDLERS = {
  [action.GET_VENDOR]: (state, action) => {
    return { ...state };
  },
  [action.SET_VENDOR]: (state, action) => {
    return { ...state, ...action.payload };
  }
};

let defaultState = {};

export const reducer = (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
